import React, { PureComponent } from 'react';

import { NODE_TYPES, getNodeText } from '../utils/doc-editor';

const getLevel = type => {
    switch (type) {
        case NODE_TYPES.headingOne:
            return 1;

        case NODE_TYPES.headingTwo:
            return 2;

        case NODE_TYPES.headingThree:
            return 3;

        default:
            return 0;
    }
}

const TocItem = ({ node, level, index, isCurrent, children, onClick }) => {
    const handleClick = () => {
        onClick && onClick(node, index);
    }

    return (
        <div className={`toc-item level-${level}` + (isCurrent ? ' current' : '')} onClick={handleClick}>
            { children }
        </div>
    )
}

const TocItemCondensed = ({ level, isCurrent }) => <div className={`toc-item-condensed level-${level}` + (isCurrent ? ' current' : '')} />

export default class DocToc extends PureComponent {
    state = {
        currentNodeIndex: -1
    }

    handleClick = (node, index) => {
        this.props.onClick && this.props.onClick(node, index);

        this.setState({
            currentNodeIndex: index
        });

        this.preventAutoUpdate = true;

        setTimeout(() => {
            this.preventAutoUpdate = false;
        }, 2000);
    }

    updateCurrentNode() {
        if (this.preventAutoUpdate) {
            return;
        }

        const currentNodeIndex = this.props.nodes.findIndex(node => {
            const nodeElement = this.props.getNodeDomElement(node);

            if (!nodeElement) {
                return false;
            }

            return nodeElement.offsetTop > this.props.scrollPosition;
        }) - 1;

        if (this.state.currentNodeIndex !== currentNodeIndex) {
            this.setState({ currentNodeIndex });
        }
    }

    componentDidUpdate() {
        this.updateCurrentNode();
    }

    componentDidMount() {
        this.updateCurrentNode();
    }

    render() {
        return (
            <div className="doc-toc-holder">
                <div className="doc-toc">
                    <div className="doc-toc-title">
                        { this.props.docName }
                    </div>

                    <div className="doc-toc-items">
                        {
                            this.props.nodes.map((node, index) => <TocItem
                                key={index}
                                isCurrent={index === this.state.currentNodeIndex}
                                index={index}
                                node={node}
                                level={getLevel(node.type)}
                                onClick={this.handleClick}
                            >{getNodeText(node)}</TocItem>)
                        }
                    </div>
                </div>

                <div className="doc-toc-condensed">
                    {
                        this.props.nodes.map((node, index) => <TocItemCondensed
                            key={index}
                            isCurrent={index === this.state.currentNodeIndex}
                            level={getLevel(node.type)}
                        />)
                    }
                </div>
            </div>
        );
    }
}
